import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Set font size command
 *
 * @class SetOptionCommand
 * @extends AbstractCommand
 */
export default class SetOptionCommand extends AbstractCommand {
    /**
     * @param {string} optionName
     * @param {AbstractItem} item
     * @param {string} oldOption
     * @param {string} newOption
     */
    constructor(optionName, item, oldOption, newOption) {
        super();
        this.option = optionName;
        this.item = item;
        this.oldOption = oldOption;
        this.newOption = newOption;
    }

    /**
     * Check if item has option field
     *
     * @return {boolean}
     */
    isValid() {
        return Object.keys(this.item.attributes).indexOf(this.option) >= 0;
    }

    /**
     * Execute command
     */
    execute() {
        if (!this.isValid()) return;

        this.item.set(this.option, this.newOption);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        if (!this.isValid()) return;

        this.item.set(this.option, this.oldOption);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Change option "${this.option}" to ${this.newOption}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SetOptionCommand = SetOptionCommand;
